
/*
 * @Author: your name
 * @Date: 2022-01-26 13:40:16
 * @LastEditTime: 2022-01-27 09:36:22
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \zhijixiehui-homepage\src\pages\index\manages\mapManager.ts
 */

import { MapData, ProvinceData, Unit } from '../models/map'
import { MapService } from '../services/mapservice'

export class MapManager {
  mapData: MapData = new MapData([], [], [], [])
  service: MapService
  unit: Unit = new Unit('', '', '')
  constructor (service: MapService) {
    this.service = service
  }

  async getMapData () {
    const res = await this.service.getMpaData()
    console.log(res)
    this.mapData = res
  }

  async getProvinceData (name: string, type: string) {
    const res = await this.service.getProvinceData(name)
    console.log(res)
    this.unit = res.filter((item: any) => item.memberType === type)
    console.log(this.unit)
  }
}
